import 'html5-boilerplate/dist/js/vendor/modernizr-3.11.2.min.js';
import 'html5-boilerplate/dist/js/plugins.js';

import LogoIti from './modules/logo-iti.js';
import ItiSlideshow from './modules/iti-slideshow.js';
import MenuHelper from './modules/menu-helper.js';


function syncHeight() {
  document.documentElement.style.setProperty(
    '--window-inner-height',
    `${window.innerHeight}px`
  );
}

document.addEventListener('DOMContentLoaded', () => {
  new LogoIti(document.querySelector('.logo-svg--mobile'), true);
  new LogoIti(document.querySelector('.logo-svg--desktop'));

  new MenuHelper();

  document.querySelectorAll('[data-glide-slideshow]').forEach(el => {
    const slds = new ItiSlideshow(el);
  });

  window.addEventListener('resize', syncHeight);

  /* People page */
  if(document.querySelector('form[name="people-filters"]')) {
    document.querySelectorAll('form[name="people-filters"] select').forEach(el => {
      el.addEventListener('change', () => {
        let params = new URLSearchParams(window.location.search);
        let group, hci;

        if(el.getAttribute('name') == 'hci-field') {
          group = params.get('group') || ''; //get group from url
          hci = el.value;
        }
        else if(el.getAttribute('name') == 'group') {
          hci = params.get('hci-field') || ''; //get hci from url
          group = el.value;
        }

        const link = window.location.origin + window.location.pathname.split('/page/')[0] + '?hci-field=' + hci + '&group=' + group;
        window.location.href = link;
      })
    });
  }

  if(document.querySelector('form[name="projects-filters"]')) {
    document.querySelectorAll('form[name="projects-filters"] select').forEach(el => {
      el.addEventListener('change', () => {
        let params = new URLSearchParams(window.location.search);
        let hci, state;

        if(el.getAttribute('name') == 'hci-field') {
          hci = el.value;
          state = params.get('state') || ''; //get state from url
        }
        else if(el.getAttribute('name') == 'state') {
          state = el.value;
          hci = params.get('hci-field') || ''; //get hci from url
        }

        const link = window.location.origin + window.location.pathname.split('/page/')[0] + '?hci-field=' + hci + '&state=' + state;
        window.location.href = link;
      })
    });
  }
});
